<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    洪湖站<br>
站点介绍<br>
洪湖站位于田贝四路与文锦北路路口处的西北侧，与田贝四路平行布置。车站临近洪湖公园，南侧为美景花园；东南侧为景湖大厦；西北侧为景鹏大厦；车站北侧为城市绿化用地；西侧为儿童游乐场。洪湖站站内设计与周边洪湖公园相呼应，以绿色为主调，粉色荷花点缀其中，展现出诗中“接天莲叶无穷碧 映日荷花别样红”的意境。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:24	23:04	7号线	3分35秒	5分55秒<br>
太安	06:25	23:53	7号线	3分35秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:23	23:04	7号线	4分钟	5分55秒<br>
太安	06:24	23:53	7号线	4分钟	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
西丽湖	06:24	00:04	7号线	4分钟	5分55秒<br>
太安	06:24	00:53	7号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
洪湖路东侧、田贝四路南侧、笋岗街道文化站田贝分站、田贝村、田贝花园、美景大厦、美景花园，洪湖公园（侧门）<br><br>
B出入口:<br>
洪湖路、文锦北路西侧（北）、田贝四路北侧，洪湖公园（侧门）<br><br>
C1出入口:<br>
文锦北路西侧（南）、田贝村、田贝花园<br><br>
C2出入口:<br>
田贝四路南侧、文锦北路东侧（南）、深圳市水田小学、田苑小区、德弘天下<br><br>
D出入口:<br>
文锦北路东侧（北）、田贝四路北侧、洪湖公园（正门）、水田一街、祥祺鹏大厦、水贝茂名大厦<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 田贝新村<br>
1路,M559<br><br>
C1出入口:<br>
公交站名： 田贝③<br>
M404路,M183,高峰专线97<br><br>
C2出入口:<br>
公交站名： 田贝②<br>
303路,307路,357路,369路,377路，M239路，M329路，M402路,M403路，M404路，M408路，高峰专线97<br><br>
D出入口:<br>
公交站名： 洪湖公园①<br>
303路,307路,312路,357路,366路,369路,371路,377路,M183,M203路,M403路,M404路,M406路<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "qihaoxian",
          title: "7号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>